import { Button } from '@rekrytering/ui/components/button'
import { Loader2, Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface GenerateButtonProps {
  readonly isPending: boolean
  readonly disabled?: boolean
  readonly onClick: () => void
}

export function GenerateButton({
  isPending,
  disabled = false,
  onClick,
}: GenerateButtonProps) {
  const { t } = useTranslation()

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={disabled || isPending}
      onClick={onClick}
    >
      {isPending ? (
        <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" />
      ) : (
        <Sparkles className="h-3.5 w-3.5 mr-1.5" />
      )}
      {isPending ? t('jobs.translations.generating') : t('ai.generate')}
    </Button>
  )
}
